var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"text-h6 text-md-h5 grey--text",attrs:{"align-center":"","justify-center":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }